import React, { useContext, useState, useMemo } from "react";
import { Button, Row, Col, ListGroup, Form } from "react-bootstrap";
import DataGrid, { SelectColumn } from "react-data-grid";
import { Typeahead, ClearButton } from "react-bootstrap-typeahead";

import StoryContext from "../store/context";
import { observer } from "mobx-react-lite";

const columnsProduct = [SelectColumn, { name: "Найменування", key: "name" }];

const sorted = (A, B) => (A.name < B.name ? -1 : 1);

function rowKeyGetter(row) {
  // console.log(JSON.stringify(row))
  return row.uuid;
}

const ReportSilpo = observer(() => {
  const [listClients, setListClients] = useState([]);
  const store = useContext(StoryContext);

  const optionsClient = useMemo(
    () =>
      store.clients
        .filter((item) => item.active === true)
        .sort((s1, s2) =>
          s1.name.toLowerCase() < s2.name.toLowerCase() ? -1 : 1
        )
        .map((item) => ({
          ...item,
          label: item.name,
          link: item,
          id: item.uuid,
        })),
    []
  );

  return (
    <>
      <Row style={{ paddingTop: 20 }}>
        <Col>
          <Row>
            <Col md={3}>
              <h5 style={{ textAlign: "center" }}>Дата заказу</h5>
            </Col>
            <Col>
              <input
                name="requested_order_ship_date"
                value={store.reportSilpo.date1Order}
                type="date"
                className="form-control"
                onChange={(event) =>
                  store.reportSilpo.setDate1Order(event.target.value)
                }
              />
            </Col>
            <Col>
              <input
                name="requested_order_ship_date"
                value={store.reportSilpo.date2Order}
                type="date"
                className="form-control"
                onChange={(event) =>
                  store.reportSilpo.setDate2Order(event.target.value)
                }
              />
            </Col>
          </Row>
          <Row style={{ paddingTop: 5 }}>
            <Col md={3}>
              <h5 style={{ textAlign: "center" }}>Дата створення</h5>
            </Col>
            <Col>
              <input
                type="datetime-local"
                id="meeting-time"
                name="meeting-time"
                value={store.reportSilpo.date1Creation}
                className="form-control"
                onChange={(event) =>
                  store.reportSilpo.setDate1Creation(event.target.value)
                }
              />
            </Col>
            <Col>
              <input
                type="datetime-local"
                id="meeting-time2"
                name="meeting-time2"
                value={store.reportSilpo.date2Creation}
                className="form-control"
                onChange={(event) =>
                  store.reportSilpo.setDate2Creation(event.target.value)
                }
              />
            </Col>
          </Row>
        </Col>
        <Col>
          {" "}
          <Row>
            <Col md={3}>
              <h5 style={{ textAlign: "center" }}>Кліент</h5>
            </Col>
            <Col>
              <Typeahead
                onChange={
                  (value) => {
                    if (value.length > 0) {
                      store.reportSilpo.setClient(value[0].link);
                      setListClients(value);
                    }
                  }

                  // console.log(value)
                }
                options={optionsClient}
                selected={listClients}
                placeholder="Виберіть кліента..."
              >
                {({ selected }) => (
                  <div className="rbt-aux">
                    {!!selected.length && (
                      <ClearButton
                        onClick={() => {
                          setListClients([]);
                          store.reportSilpo.delClient();
                        }}
                      />
                    )}
                  </div>
                )}
              </Typeahead>
            </Col>
            <Col>
              <Button onClick={() => store.reportSilpo.setExcel()}>
                Сформувати
              </Button>
            </Col>
          </Row>
        </Col>
        ˝
      </Row>
    </>
  );
});

export default ReportSilpo;
